import { useContext, useState } from "react";
import { useToast } from "../ToastContext";
import { LoadingContext } from "../LoadingContext";
import { AuthContext } from "../AuthContext";
import {
  createTemplatesGat,
  deleteTemplatesGat,
  getTemplateDocxGat,
  getTemplatesByUserIdGat,
  getTemplatesGat,
  saveTemplateDocxGat,
  updateTemplatesGat
} from "../../gateways/TemplatesGateway";
import formatDateBr from "../../utils/formatDateBr";

export interface TemplatesType {
  id?: string;
  name: string;
  email: string;
  phoneNumber: string;
}

export default function useTemplates() {
  const showToast = useToast();
  const { setLoading } = useContext(LoadingContext);
  const { objUserTk } = useContext(AuthContext);

  const [formValuesTemplates, setFormValuesTemplates] = useState<TemplatesType>({
    email: "",
    name: "",
    phoneNumber: "",
  });
  const [tableTemplates, setTableTemplates] = useState<any[]>([]);
  const [totalTemplates, setTotalTemplates] = useState<number>(0);

  const updateTemplates = async (id: string, nameTemplate: string, editorHtml: string) => {
    try {
      setLoading(true);

      const data = {
        id,
        nameTemplate,
        template: editorHtml,
        userId: objUserTk.UserId,
      };

      const result = await updateTemplatesGat(data);
      if (result) {
        showToast("success", "Sucesso ao atualizar");
        setLoading(false);
        // getTemplatesByUserId(1);
      }
    } catch (error: any) {
      console.log(error);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao cadastrar"
      );
      setLoading(false);
    }
  };

  const createTemplates = async (nameTemplate: string, editorHtml: string) => {
    try {
      setLoading(true);

      const data = {
        NameTemplate: nameTemplate,
        Template: editorHtml,
        UserId: objUserTk.UserId,
      };

      const result = await createTemplatesGat(data);
      if (result) {
        showToast("success", "Sucesso ao cadastrar");
        setLoading(false);
        // getTemplatesByUserId(1);
      }
    } catch (error: any) {
      console.log(error);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao cadastrar"
      );
      setLoading(false);
    }
  };

  const saveDocxTemplate = async (
    nameTemplate: string,
    file: Blob,
    fileName: string,
    templateId?: string
  ) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file, fileName || "template.docx");
      formData.append("nameTemplate", nameTemplate);
      formData.append("userId", String(objUserTk.UserId));
      if (templateId) {
        formData.append("id", templateId);
      }
      const result = await saveTemplateDocxGat(formData);
      if (result) {
        setLoading(false);
        queueMicrotask(() =>
          showToast("success", "Template DOCX salvo com sucesso")
        );
        return true;
      }
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      queueMicrotask(() =>
        showToast(
          "error",
          error?.response?.data?.message ||
            error?.response?.data?.error?.message ||
            "Erro ao salvar template DOCX"
        )
      );
    }
    return false;
  };

  const fetchTemplateDocxBuffer = async (templateId: string) => {
    try {
      setLoading(true);
      const buffer = await getTemplateDocxGat(templateId, objUserTk.UserId);
      setLoading(false);
      return buffer;
    } catch (error: any) {
      console.log(error);
      showToast(
        "error",
        error?.response?.data?.message || "Erro ao carregar DOCX do template"
      );
      setLoading(false);
    }
    return undefined;
  };

  /** Um único loading + ordem estável: fecha spinner antes do toast ao carregar o editor DOCX. */
  const loadDocxEditorContext = async (templateId: string) => {
    try {
      setLoading(true);
      const result = await getTemplatesGat(templateId);
      const meta = result?.data?.data as any;
      if (!meta) {
        setLoading(false);
        showToast("error", "Não foi possível carregar o template.");
        return null;
      }

      let buffer: ArrayBuffer | undefined;
      if (meta.templateDocxPath) {
        try {
          buffer = await getTemplateDocxGat(templateId, objUserTk.UserId);
        } catch (error: any) {
          setLoading(false);
          showToast(
            "error",
            error?.response?.data?.message ||
              "Não foi possível carregar o arquivo DOCX."
          );
          return { meta, buffer: undefined };
        }
      }

      setLoading(false);
      return { meta, buffer };
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao carregar template"
      );
      return null;
    }
  };

  const deleteTemplates = async (id: string) => {
    try {
      setLoading(true);

      const result = await deleteTemplatesGat(id);
      if (result) {
        showToast("success", "Sucesso ao deletar");
        setLoading(false);
        getTemplatesByUserId(1)
      }
    } catch (error: any) {
      console.log(error);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao cadastrar"
      );
      setLoading(false);
    }
  };

  const getTemplates = async (id: string) => {
    try {
      setLoading(true);

      const result = await getTemplatesGat(id);
      if (result) {
        setLoading(false);
        return result.data.data;
      }
    } catch (error: any) {
      console.log(error);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao carregar"
      );
      setLoading(false);
    }
  };

 const getTemplatesByUserId = async (page: number) => {
    try {
      setLoading(true);
      const result = await getTemplatesByUserIdGat(objUserTk.UserId, page, 5);
      if (result) {

        setTotalTemplates(Math.ceil(result.data?.data?.totalContacts / 5))

        const tableResult = result.data?.data?.templates?.map((item: any) => ({
          id: item.id,
          nameTemplate: item.nameTemplate,
          data: formatDateBr(item.createdDate),
          templateDocxPath:
            item.templateDocxPath ?? item.TemplateDocxPath ?? null,
        }));
        setTableTemplates(tableResult);
        setLoading(false);
        return result.data.data;
      }
    } catch (error: any) {
      console.log(error);
        showToast("error", error?.message || "Erro ao cadastrar");
        setLoading(false);
    }
  };

  return {
    getTemplatesByUserId,
    deleteTemplates,
    createTemplates,
    updateTemplates,
    getTemplates,
    saveDocxTemplate,
    fetchTemplateDocxBuffer,
    loadDocxEditorContext,
    setFormValuesTemplates,
    formValuesTemplates,
    tableTemplates,
    totalTemplates,
  };
}
